export default "__VITE_ASSET__CbS$O0Dm__"